import React from 'react';
import './privacypolicy.css';

export default function Privacyolicy() {
  return (
    <section id='privacypolicy-section'>
      <div id='privacypolicy-cont'>
        <h1 >
          Privacy Policy
        </h1>
        <p><strong>Effective Date:</strong> [Insert Date]</p>
        <p>
          This Privacy Policy explains how we handle your information when you use our website.
          We are committed to protecting your privacy and ensuring transparency regarding the
          technologies and services used on our platform. By using this site, you agree to the
          terms outlined below.
        </p>

        <h2>1. Information We Collect</h2>
        <p>
          We do not directly collect, store, or process any personal data from users who visit
          or interact with our website.
        </p>

        <h2>2. Third-Party Services</h2>
        <p>
          Our website integrates with third-party services to enhance its functionality. While
          we do not collect or store user data, these services may collect limited information
          such as:
        </p>
        <ul>
          <li>
            <strong>OneSignal:</strong> Used for push notifications. OneSignal may collect
            device-specific information to deliver notifications. Refer to their
            <a
              href="https://onesignal.com/privacy_policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'blue', textDecoration: 'none' }}
            >
              Privacy Policy
            </a>.
          </li>
          <li>
            <strong>MongoDB Atlas:</strong> Used for backend database management. No user-specific
            data is stored or processed by us directly.
          </li>
          <li>
            <strong>Airtable:</strong> Used for managing backend operations. Airtable may collect
            metadata related to API usage. Refer to their
            <a
              href="https://www.airtable.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'blue', textDecoration: 'none' }}
            >
              Privacy Policy
            </a>.
          </li>
          <li>
            <strong>React and JavaScript:</strong> These frameworks ensure smooth application
            functionality and do not collect user data.
          </li>
        </ul>

        <h2>3. How Information is Used</h2>
        <p>
          Any information collected by the third-party services mentioned above is used to:
        </p>
        <ul>
          <li>Provide essential website functionality</li>
          <li>Improve your experience on our site</li>
        </ul>
        <p>We do not process or analyze any user data directly.</p>

        <h2>4. Cookies</h2>
        <p>
          Our website does not use cookies or similar tracking technologies.
        </p>

        <h2>5. Your Rights</h2>
        <p>
          Since we do not collect or store your data, there are no personal records for access,
          correction, or deletion. However, you may review the privacy policies of the third-party
          services we use to understand their data practices.
        </p>

        <h2>6. Security</h2>
        <p>
          While we do not handle user data directly, we ensure that the third-party services
          integrated with our website adhere to industry-standard security practices.
        </p>

        <h2>7. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be reflected on
          this page, so we encourage you to review it periodically.
        </p>

        <h2>8. Contact Us</h2>
        <p>
          If you have any questions or concerns regarding this Privacy Policy or how third-party
          services are used on our platform, please contact us at:
        </p>
        <p>
          <strong>Email:</strong> 
          <a
            href="mailto:prasannasimha5002@gmail.com"
            style={{ color: 'blue', textDecoration: 'none' }}
          >
            prasannasimha5002@gmail.com
          </a>
        </p>
      </div>
    </section>
  );
}
